import { FC } from 'react';
import PaymentsFailure from 'src/components/Payments/Failure';
import useQueryParams from 'src/hooks/useQueryParams';
const TossPaymentFailureView: FC = () => {
  const {
    code: errorCode
  } = useQueryParams<{
    code: string;
    message: string;
    orderId: string;
  }>() || {};
  return <PaymentsFailure errorCode={errorCode} data-sentry-element="PaymentsFailure" data-sentry-component="TossPaymentFailureView" data-sentry-source-file="TossPaymentFailure.tsx" />;
};
export default TossPaymentFailureView;